<div class="container-rosa" [hidden]="!options.length" *ngIf="tema === 'ROSA'">
  <button
    *ngFor="let option of options"
    [ngClass]="{select: option.id === currentIdSelected }"
    (click)="selectOption(option)"
  >
    <i class="material-icons"> {{ option.icon }} </i>
    {{ option.label }}
  </button>
</div>

<div class="container" [hidden]="!options.length" *ngIf="tema !== 'ROSA'">
  <button
    *ngFor="let option of options"
    [ngClass]="{select: option.id === currentIdSelected }"
    (click)="selectOption(option)"
  >
    <i class="material-icons"> {{ option.icon }} </i>
    {{ option.label }}
  </button>
</div>
